
import { AirmarAnalyticsSettingsApiModel } from "@aus/Services/AirmarSystemSettingsService";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { Draft } from "immer";

export interface AirmarAnalyticsSettingsModel {
    googleTrackingTypeComputed?: string;
    googleTrackingAccountId?: string;
}

export interface AirmarAnalyticsSettingsState {
    isLoading: boolean;
    value?: AirmarAnalyticsSettingsModel;
}

const initialState: AirmarAnalyticsSettingsState = {
    isLoading: false,
};

const normalizeAnalyticsSettings = (
    result?: AirmarAnalyticsSettingsApiModel,
): AirmarAnalyticsSettingsModel | undefined => {
    if (!result) {
        return undefined;
    }

    return {
        googleTrackingTypeComputed: result.googleTrackingTypeComputed ?? result.GoogleTrackingTypeComputed,
        googleTrackingAccountId: result.googleTrackingAccountId ?? result.GoogleTrackingAccountId,
    };
};

const reducer = createTypedReducerWithImmer(initialState, {
    "Custom/AirmarAnalyticsSettings/BeginLoad": (draft: Draft<AirmarAnalyticsSettingsState>) => {
        draft.isLoading = true;
    },
    "Custom/AirmarAnalyticsSettings/CompleteLoad": (
        draft: Draft<AirmarAnalyticsSettingsState>,
        action: { result?: AirmarAnalyticsSettingsApiModel },
    ) => {
        draft.isLoading = false;
        draft.value = normalizeAnalyticsSettings(action.result);
    },
});

(reducers as any).airmarAnalyticsSettings = reducer;

export type AirmarAnalyticsSettingsAppState = {
    airmarAnalyticsSettings: AirmarAnalyticsSettingsState;
} & ApplicationState;

type Reducers = {
    airmarAnalyticsSettings: typeof reducer;
};

export type AirmarAnalyticsSettingsActions = Parameters<Reducers[keyof Reducers]>[1] | AnyAction;